import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toDateString } from '../../../../util/DateUtility';
import Has from '../../../../component/Permission/Has';
import { G_EXPORT_TRANSACTION, PAY_OVERVIEW_STOP_PAYMENT, U_VIEW_USERS, U_USER_ADMIN, G_ADMIN_USER, REGISTER_COMPANIES } from '../../../../config/PermissionTypes';
import { activateUser, getUserUUID } from '../../../../service/UserService';
import ActivateUserModal from '../../../User/ActivateUserModal';
import LoadingSpinner from '../../../LoadingSpinner/LoadingSpinner';

export default function AdminUserOverview(props) {

    const { user, updateUser } = props;
    const [currentUserUUID, setCurrentUserUUID] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);

    const UUIDDataHandler = (uuid) => {
        setCurrentUserUUID(uuid.data);
        setIsLoading(false);
    }

    const activateModalHandler = () => {
        if (!user.isActive) {
            setIsLoading(true);
            activateUser(user.uuid, "Activate", !user.isActive, () => { setIsLoading(false); })
            handleUpdateUser();
        }
        else {
            setIsActivateModalOpen(true);
        }
    }

    const handleUpdateUser = () => {
        user.isActive = !user.isActive
        updateUser(user.uuid, user.isActive);
    }

    useEffect(() => {
        getUserUUID(UUIDDataHandler);
    }, []);

    if (user === null) {
        return <div>User not found.</div>
    }

    //check for null dates
    const createdDate = user.createdDate ? toDateString(user.createdDate) : "N/A";

    const userPermissions = (user.permissions && !user.isSuper) ? user.permissions : [];

    // List of available Dashboard permissions
    let userDashboardPerms = [];

    // List of available Payments tables permissions
    let userPaymentsPerms = [];
    if (userPermissions.includes(G_EXPORT_TRANSACTION)) userPaymentsPerms.push({ displayName: "Export Data", testId: "payment-permission-export-data" });
    if (userPermissions.includes(PAY_OVERVIEW_STOP_PAYMENT)) userPaymentsPerms.push({ displayName: "Stop Payment", testId: "payment-permission-stop-payment" });

    // List of available User Admin permissions
    let userUserAdminPerms = [];
    if (userPermissions.includes(U_VIEW_USERS)) userUserAdminPerms.push({ displayName: "View Users", testId: "user-admin-permission-view-users" });
    if (userPermissions.includes(U_USER_ADMIN)) userUserAdminPerms.push({ displayName: "User Management", testId: "user-admin-permission-user-management" });

    let registerCompaniesPerms = [];
    if (userPermissions?.includes(REGISTER_COMPANIES)) registerCompaniesPerms.push({ displayName: "Register Companies", testId: "register-companies-permission" });

    const hasPermissions = userDashboardPerms.length > 0 || userPaymentsPerms.length > 0 || userUserAdminPerms.length > 0 || registerCompaniesPerms.length > 0;

    return (
        isLoading ? <div id="dashboard-loader">
            <LoadingSpinner blue />
        </div> :
            <div className="efup-user-side-panel-overview" data-testid="efup-user-side-panel-overview">
                <div className="efup-side-panel-line">
                    <table className="table table-borderless" data-testid="efup-overview-tab-body">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="efup-side-panel-label">User ID:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-username">{user.username}</td>
                            </tr>
                            <tr>
                                <td className="efup-side-panel-label">Name:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-name">{user.name}</td>
                            </tr>
                            <tr>
                                <td className="efup-side-panel-label">Customer ID:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-customerId">{user.customerId}</td>
                            </tr>
                            <tr>
                                <td className="efup-side-panel-label">Companies:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-companies">{user.companies.sort().join(", ")}</td>
                            </tr>
                            <tr>
                                <td className="efup-side-panel-label">Status:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-status">{user.isActive ? "Active" : "Inactive"}</td>
                            </tr>
                            <tr>
                                <td className="efup-side-panel-label">Created Date:</td>
                                <td className="efup-side-panel-data" data-testid="efup-overview-tab-create-date">{createdDate}</td>
                            </tr>
                        </tbody>
                    </table>
                    {user.internalRole.roleName &&
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td className="efup-sub-header" data-testid="efup-overview-tab-role-section">Internal Role:</td>
                                    <td className="efup-side-panel-data" data-testid="efup-overview-tab-role-name">{user.internalRole.roleName}</td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    {user.internalRole.roleName &&
                        <div className="efup-sub-header" data-testid="efup-overview-tab-permissions-section">Permissions</div>}
                    {hasPermissions ?
                        <div>
                            <div className="row">
                                {userDashboardPerms.length > 0 &&
                                    <div className="col" data-testid="efup-overview-dashboard-permissions-section">
                                        <p className="efup-side-panel-label">Dashboard</p>
                                        <div className="efup-permissions-list-item">
                                            <ul>
                                                {userDashboardPerms.map((perm, i) => {
                                                    return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                        {perm.displayName}
                                                    </label></li>
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {userPaymentsPerms.length > 0 &&
                                    <div className="col" data-testid="efup-overview-payments-permissions-section">
                                        <p className="efup-side-panel-label">Payment Pages</p>
                                        <div className="efup-permissions-list-item">
                                            <ul>
                                                {userPaymentsPerms.map((perm, i) => {
                                                    return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                        {perm.displayName}
                                                    </label></li>
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {userUserAdminPerms.length > 0 &&
                                    <div className="col" data-testid="efup-overview-useradmin-permissions-section">
                                        <p className="efup-side-panel-label">User Admin</p>
                                        <div className="efup-permissions-list-item">
                                            <ul>
                                                {userUserAdminPerms.map((perm, i) => {
                                                    return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                        {perm.displayName}
                                                    </label></li>
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {registerCompaniesPerms.length > 0 &&
                                    <div className="col" data-testid="efup-overview-register-companies-permissions-section">
                                        <p className="efup-side-panel-label">Register Companies</p>
                                        <div className="efup-permissions-list-item">
                                            <ul>
                                                {registerCompaniesPerms.map((perm, i) => {
                                                    return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                        {perm.displayName}
                                                    </label></li>
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        : user.isSuper ? <div className="efup-permissions-list-item">
                            <ul>
                                <li><label className="efup-permissions-list-item-label">All</label></li>
                            </ul>
                        </div>
                            : user.internalRole.roleName && <div className="efup-side-panel-data">No permissions assigned to this user.</div>
                    }
                </div>
                {user.isSuper && currentUserUUID !== user.uuid ?
                    <Has permission={G_ADMIN_USER}>
                        <div className="ocButtons">
                            <Link onKeyDown={({ key }) => key === "Enter" ? "" : ""}
                                className="edit-cell"
                                to={`/system/users/${user.username}/edit`}
                                data-testid={`edit-user-link-${user.username}`}
                                state={{ username: user.username, userUuid: user.uuid }}>
                                <button type="button" className="oc-blue-btn" data-testid="efup-overview-tab-edit-user-button">Edit User</button>
                            </Link>
                            <button
                                onClick={activateModalHandler}
                                type="button"
                                className="oc-blue-btn"
                                data-testid="efup-overview-tab-activate-user-button"
                            >
                                {user.isActive ? "Inactivate User" : "Activate User"}
                            </button>
                        </div>
                    </Has>
                    : currentUserUUID !== user.uuid ?
                        <div className="ocButtons">
                            <Link onKeyDown={({ key }) => key === "Enter" ? "" : ""}
                                className="edit-cell"
                                to={`/system/users/${user.username}/edit`}
                                data-testid={`edit-user-link-${user.username}`}
                                state={{ username: user.username, userUuid: user.uuid }}>
                                <button type="button" className="oc-blue-btn" data-testid="efup-overview-tab-edit-user-button">Edit User</button>
                            </Link>
                            <button
                                onClick={activateModalHandler}
                                type="button"
                                className="oc-blue-btn"
                                style={{ backgroundColor: user.isActive ? '#e30000' : '#0078B5' }}
                                data-testid="efup-overview-tab-activate-user-button"
                            >
                                {user.isActive ? "Inactivate User" : "Activate User"}
                            </button>
                        </div>
                        : <div />
                }
                <ActivateUserModal
                    isActivateModalOpen={isActivateModalOpen}
                    setIsActivateModalOpen={setIsActivateModalOpen}
                    activateChangeTo={!user.isActive}
                    user={user}
                    updateUser={handleUpdateUser}
                    companyNumber={""}
                />
            </div>
    );
}